/**
 * @fileoverview NoSound component for rendering a no sound question
 *
 * @example
 * // Usage in component:
 * import { NoSound } from './NoSound'
 *
 * <NoSound onSubmit={onSubmit} question={question} />
 */

import { Instructions } from './sections/Instructions'

import { NavigationButton } from '../NavigationButton'
import { Text } from '../typography/Typography'
import css from './Checkbox.module.css'
import { List } from './sections/List'
import { Title } from './sections/Title'

/**
 * @function NoSound
 * @description Component for rendering a no sound question
 * @param {Novoic.CheckboxQuestionProps} props - The props for the component
 * @returns {JSX.Element} The NoSound component
 */
export function NoSound({ onSubmit, question }: Novoic.CheckboxQuestionProps) {
    const { id, question: body } = question
    const { title, instructions, list, subtext, checkboxes } = body

    const state = checkboxes.map((checkbox) => ({
        ...checkbox,
        value: checkbox.default,
        pristine: true,
    }))

    return (
        <div className={css.container}>
            <Title>{title}</Title>
            {subtext && <Text>{subtext}</Text>}
            {list && <List list={list} />}
            {instructions && <Instructions instructions={instructions} />}

            <div className={css.button_container}>
                <NavigationButton
                    type="confirm"
                    label={body.button}
                    onClick={() =>
                        onSubmit(id, {
                            checkboxes: state.reduce((acc, checkbox) => {
                                acc[checkbox.name] = checkbox.value
                                return acc
                            }, {} as Record<string, boolean>),
                        })
                    }
                />
            </div>
        </div>
    )
}
